import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
  styleUrls: ['./select-item.component.css'],
  standalone: false
})
export class SelectItemComponent {

  @Input() itemText = 'text'
  @Input() itemSubtext!: string;
  @Input() itemThirdText!: string;
  @Input() itemSuffixText!: string;
  @Input() itemSuffixSubtext!: string;
  @Input() color = 'black'
  @Input() iconName?:string
  @Input() srcIcon?:string;
  @Input() south = false
  @Input() displayArrow = true;
  @Input() stars?: number;
  @Input() className!: string;
  @Input() patientName!: string;
  @Input() template!: TemplateRef<any>;

}
